<template>
  <div class="follow-wrapper">
    <div class="title"></div>
    <div class="tip">权限受限，请联系工作人员</div>
  </div>
</template>

<script>
export default {
  name: 'h5Follow',
  data () {
    return {
      qrUrl: '',
    }
  },
  mounted () {
    const { qr } = this.$route.query
    this.qrUrl = qr ? decodeURIComponent(qr) : process.env.VUE_APP_FOLLOW_QR
  },
}
</script>

<style src="./index.scss" lang="scss"></style>
